import network from '@/services/network';
import { ApiResponse, DashboardCard, DashboardCardPayload } from '@/types';
import { ErrorResponse } from '@/utils';

const getDashboardCards = async (): Promise<{ data: DashboardCard[] }> => {
  try {
    const { data } = await network.get<{ data: DashboardCard[] }>('/dashboard-cards');
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const createDashboardCard = async (
  payload: DashboardCardPayload,
): Promise<ApiResponse<DashboardCard>> => {
  try {
    const { data } = await network.post<ApiResponse<DashboardCard>>(
      '/dashboard-cards',
      payload,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const updateDashboardCard = async (
  id: number,
  payload: DashboardCardPayload,
): Promise<ApiResponse<DashboardCard>> => {
  try {
    const { data } = await network.put<ApiResponse<DashboardCard>>(
      `/dashboard-cards/${id}`,
      payload,
    );
    return data;
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const deleteDashboardCard = async (id: number): Promise<void> => {
  try {
    await network.delete(`/dashboard-cards/${id}`);
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const reorderDashboardCards = async (
  order: { id: number; sort_order: number }[],
): Promise<void> => {
  try {
    await network.post('/dashboard-cards/reorder', { order });
  } catch (error) {
    throw new ErrorResponse(error);
  }
};

const dashboardCardsApi = {
  getDashboardCards,
  createDashboardCard,
  updateDashboardCard,
  deleteDashboardCard,
  reorderDashboardCards,
};

export default dashboardCardsApi;
